
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingItemsGrid extends Serenity.EntityGrid<SKUSplittingItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUSplittingItems'; }
        protected getDialogType() { return SKUSplittingItemsDialog; }
        protected getIdProperty() { return SKUSplittingItemsRow.idProperty; }
        protected getInsertPermission() { return SKUSplittingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUSplittingItemsRow.localTextPrefix; }
        protected getService() { return SKUSplittingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}